import IncidentAddFormModal from './IncidentAddFormModal.view';
export default IncidentAddFormModal;
